// extracted by mini-css-extract-plugin
module.exports = {"hidden":"index_hidden_1hyYS","text-default":"index_text-default_1Ak38","topbar":"index_topbar_3i0eD"};